import React from 'react';
import PropTypes from 'prop-types';

import { DropzoneArea as MatDropzoneArea } from 'material-ui-dropzone';
import { useTranslation } from 'react-i18next';
import { UiDropzoneUploader } from './DropzoneUploader.style';


/**
 * 上傳組件
 */

export const DropzoneUploader = ({ filesLimit, onChange, acceptedFiles = [], ...otherProps }) => {
  const { t } = useTranslation();
  return (
    <UiDropzoneUploader>
      <MatDropzoneArea
        dropzoneText={t('common.dropzone_text')}
        getFileLimitExceedMessage={() => t('common.dropzone_limit_text')}
        getFileAddedMessage={() => t('common.dropzone_add_text')}
        getFileRemovedMessage={() => t('common.dropzone_remove_text')}
        filesLimit={filesLimit}
        onChange={file => onChange(file)}
        getDropRejectMessage={() => '檔案類型不正確或檔案大小超過1.5GB，請確認您的檔案類型再次重新上傳！'}
        maxFileSize={1500000000}
        acceptedFiles={acceptedFiles}
        {...otherProps}
      />
    </UiDropzoneUploader>
  );
};

DropzoneUploader.propTypes = {
  props: PropTypes.object,
  filesLimit: PropTypes.number,
  onChange: PropTypes.func,
};


